<template>
  <div class="container">
    <h1 class="page-title">Offset Your Current Switch</h1>
    <h5>We just need you Switch ID</h5>
    <div class="row _margin-top-40">
      <div class="col-sm-4 col-md-4">
        <div class="card">
          <form name="form">
            <label for="id">Your Switch Id</label>

            <div class="row">
              <div class="col-md-12">
                <validation-messages label="Switch Id" :$v="$v.form.id">
                  <form-field id="id" v-model="form.id" :error="$v.form.id.$error" />
                </validation-messages>
              </div>
            </div>

            <uiv-btn class="_margin-top-20" type="primary" size="lg" block :disabled="requesting" @click="onSubmit">
              <loader :show="requesting" />See Projects
            </uiv-btn>

            <uiv-alert class="_margin-top-30" type="danger" v-if="error">
              We could not find a switch with this Id
            </uiv-alert>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  required, maxLength, minLength, numeric
} from 'vuelidate/lib/validators';

export default {
  name: 'CarbonOffsetExisting',
  data() {
    return {
      error: false,
      requesting: false,
      form: {
        id: null
      }
    }
  },
  validations() {
    return {
      form: {
        id: {
          required,
          numeric,
          minLength: minLength(1),
          maxLength: maxLength(10)
        }
      }
    }
  },
  methods: {
    async onSubmit() {
      this.error = false;
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.requesting = true;
      const found = await this.$store.dispatch('carbon_offset/getCarbonEquivalent', this.form.id);
      this.requesting = false;

      if (!found) {
        this.error = true;
      } else {
        await this.$store.dispatch('storage/save', {
          prop: 'uuid',
          value: this.form.id
        });

        this.$router.push({ name: 'carbonOffset' });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 40px;
}
</style>
